import React from 'react';
import styles from './PrivacyPolicyPage.module.css';

const PrivacyPolicyPage = () => {
  return (
    <div className={styles.container}>
      <h1>Aviso de Privacidad</h1>
      <div className={styles.content}>
        <p>
          Alberto Rodríguez Salas y/o SEAL MARKET, con domicilio en calle Pról. Pino Suárez #3012, colonia J.
          Guadalupe Rodríguez, ciudad Durango, municipio o delegación Durango, c.p. 34280, país México, y portal de
          internet www.sealmarket.mx, es el responsable del uso y protección de sus datos personales, y al respecto le
          informamos lo siguiente:
        </p>

        <h2>¿Para qué fines utilizaremos sus datos personales?</h2>
        <p>
          Los datos personales que recabamos de usted, los utilizaremos para las siguientes finalidades que son
          necesarias para el servicio que solicita:
        </p>
        <ul>
          <li>Integrar su expediente de información y registrarlo en nuestra base de datos.</li>
          <li>Emitir la factura que ampare los servicios y/o productos prestados</li>
          <li>Proveer, procesar, completar y darle seguimiento a los servicios y/o productos requeridos por usted</li>
          <li>Informar el estado de su crédito y hacer recordatorios de adeudos</li>
          <li>Realizar y gestionar la cobranza (internamente o mediante terceros)</li>
          <li>Elaborar y celebrar contratos para la adquisición de productos o servicios</li>
          <li>Generar cualquier otra información financiera o contable necesaria para dar cumplimiento a obligaciones de carácter fiscal o comercial</li>
        </ul>
        <p>
          De manera adicional, utilizaremos su información personal para las siguientes finalidades secundarias que no
          son necesarias para el servicio solicitado, pero que nos permiten y facilitan brindarle una mejor atención:
        </p>
        <ul>
          <li>Mercadotecnia o publicitaria</li>
          <li>Desarrollar y comunicar de nuevos productos y servicios</li>
        </ul>
        <p>
          En caso de que no desee que sus datos personales sean tratados para estos fines secundarios, desde este
          momento usted nos puede comunicar lo anterior a través del siguiente mecanismo:
          vía correo electrónico a la dirección: ventasdgo@sealmarket.mx
        </p>
        <p>
          La negativa para el uso de sus datos personales para estas finalidades no podrá ser un motivo para que le
          neguemos los servicios y productos que solicita o contrata con nosotros.
        </p>

        <h2>¿Qué datos personales utilizaremos para estos fines?</h2>
        <p>
          Para llevar a cabo las finalidades descritas en el presente aviso de privacidad, utilizaremos los siguientes datos
          personales:
        </p>
        <ul>
          <li>Datos de identificación</li>
          <li>Datos de contacto</li>
          <li>Datos laborales</li>
        </ul>

        <h2>¿Con quién compartimos su información personal y para qué fines?</h2>
        <p>
          Le informamos que sus datos personales son compartidos dentro del país con las siguientes personas,
          empresas, organizaciones o autoridades distintas a nosotros, para los siguientes fines:
        </p>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Destinatario de los datos personales</th>
              <th>Finalidad</th>
              <th>Requiere del consentimiento</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Buró legal</td>
              <td>Mantenimiento o cumplimiento de la relación jurídica entre nosotros y usted.</td>
              <td>No</td>
            </tr>
          </tbody>
        </table>

        <h2>¿Cómo puede acceder, rectificar o cancelar sus datos personales, u oponerse a su uso?</h2>
        <p>
          Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones
          del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en
          caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros
          registros o bases de datos cuando considere que la misma no está siendo utilizada adecuadamente
          (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición). Estos
          derechos se conocen como derechos ARCO.
        </p>
        <p>
          Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva a través del
          siguiente medio:
          Llamando al número telefónico (618)812 27 58, o vía correo electrónico a la dirección:
          ventasdgo@sealmarket.mx
        </p>
        <p>
          Para conocer el procedimiento y requisitos para el ejercicio de los derechos ARCO, ponemos a su disposición el
          siguiente medio:
          Llamando al número telefónico (618)812 27 58, o vía correo electrónico a la dirección:
          ventasdgo@sealmarket.mx
        </p>
        <p>
          Los datos de contacto de la persona o departamento de datos personales, que está a cargo de dar trámite a las
          solicitudes de derechos ARCO, son los siguientes:
        </p>
        <ul>
          <li>a) Nombre de la persona o departamento de datos personales: RESPONSABLE DEL ÁREA DE PROTECCIÓN DE DATOS PERSONALES</li>
          <li>b) Domicilio: calle Pról. Pino Suárez #3012, colonia Col. J. Guadalupe Rodríguez, ciudad Durango, municipio o delegación Durango, c.p. 34280, en la entidad de Durango, país México</li>
          <li>c) Correo electrónico: ventasdgo@sealmarket.mx</li>
          <li>d) Número telefónico: (618)812 27 58</li>
        </ul>

        <h2>Usted puede revocar su consentimiento para el uso de sus datos personales</h2>
        <p>
          Usted puede revocar el consentimiento que, en su caso, nos haya otorgado para el tratamiento de sus datos
          personales. Sin embargo, es importante que tenga en cuenta que no en todos los casos podremos atender su
          solicitud o concluir el uso de forma inmediata, ya que es posible que por alguna obligación legal requiramos
          seguir tratando sus datos personales. Asimismo, usted deberá considerar que para ciertos fines, la revocación de
          su consentimiento implicará que no le podamos seguir prestando el servicio que nos solicitó, o la conclusión de
          su relación con nosotros.
        </p>
        <p>
          Para revocar su consentimiento deberá presentar su solicitud a través del siguiente medio:
          Llamando al número telefónico (618)812 27 58, o vía correo electrónico a la dirección:
          ventasdgo@sealmarket.mx
        </p>
        <p>
          Para conocer el procedimiento y requisitos para la revocación del consentimiento, ponemos a su disposición el
          siguiente medio:
          Llamando al número telefónico (618)812 27 58, o vía correo electrónico a la dirección:
          ventasdgo@sealmarket.mx
        </p>

        <h2>¿Cómo puede limitar el uso o divulgación de su información personal?</h2>
        <p>
          Con objeto de que usted pueda limitar el uso y divulgación de su información personal, le ofrecemos los
          siguientes medios:
          Llamando al número telefónico (618)812 27 58, o vía correo electrónico a la dirección:
          ventasdgo@sealmarket.mx
        </p>

        <h2>¿Cómo puede conocer los cambios en este aviso de privacidad?</h2>
        <p>
          El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos
          requerimientos legales; de nuestras propias necesidades por los productos o servicios que ofrecemos; de
          nuestras prácticas de privacidad; de cambios en nuestro modelo de negocio, o por otras causas.
        </p>
        <p>
          Nos comprometemos a mantenerlo informado sobre los cambios que pueda sufrir el presente aviso de
          privacidad, a través de: envío de correo electrónico y la publicación del aviso de privacidad actualizado en
          nuestra página www.sealmarket.mx.
        </p>
        <p>
          El procedimiento a través del cual se llevarán a cabo las notificaciones sobre cambios o actualizaciones al
          presente aviso de privacidad es el siguiente:
          Envío de correo electrónico y mediante un anuncio en el local donde se ofrece el servicio.
        </p>
        <p className={styles.update}>Última actualización: 09/10/2025</p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
